import { getCanvasCoord } from '../../utils/utils.js'
import { updateHistoryStackBeforeSelect } from '../../utils/undoRedoUtils.js'

export const handleSelectDown = (e, state) => {
  const {
    boardId,
    // dragging
    setIsDragging,
    setSelectionRect,
    setSelectionRectPathKeys,
    draggingRect,
    draggingStartPos,
    draggingCurrentPos,
    // selectionBox move&&resize
    clientCoord,
    pathsAtPointerDown,
    selectCoordinateAtPointerDown,
    paths,
    scope,
    translate,
    selectionRect,
    tmpSelectionRect,
    selectionRectPathKeys,
    setIsResizeActive,
    setIsSelectedMovingActive,
    resizeDirection,
    // history
    historyStack,
    setHistoryStack,
  } = state

  //==================== [ CASE 1: 캔버스 또는 path 클릭 시 ] ====================
  // → 새 선택 박스를 그리기 시작 (기존 선택 무시)
  if (e.target.id === 'sg-canvas' || e.target.id.includes('path')) {
    setIsDragging(true)
    setSelectionRect({ top: 0, left: 0, width: 0, height: 0 })
    setSelectionRectPathKeys([])

    // 드래깅 시작 지점 및 현재 지점 초기화 (캔버스 좌표 기준)
    draggingRect.current = { top: 0, left: 0, right: 0, bottom: 0, width: 0, height: 0 }
    draggingStartPos.current = getCanvasCoord(clientCoord, translate, scope)
    draggingCurrentPos.current = getCanvasCoord(clientCoord, translate, scope)
  }
  //==================== [ CASE 2: 기존 선택 박스 클릭 시 ] ====================
  // → 이동 또는 리사이즈 가능 (상태 백업 및 동작 구분)
  else if (e.target.id.includes('selection')) {
    // --- 선택된 path 상태 백업 ---
    for (let key of selectionRectPathKeys) {
      pathsAtPointerDown.current[key] = { ...paths[key] }
    }

    // --- 선택 박스 및 클릭 좌표 상태 백업 ---
    tmpSelectionRect.current = { ...selectionRect }
    selectCoordinateAtPointerDown.current = getCanvasCoord(clientCoord, translate, scope)

    // [2-1] 선택 박스 내부 클릭 → 이동 시작
    if (e.target.id === 'sg-selection') {
      setIsSelectedMovingActive(true)
    }

    // [2-2] 선택 박스의 테두리 or 코너 클릭 → 리사이즈 시작
    if (e.target.id.includes('border') || e.target.id.includes('corner')) {
      setIsResizeActive(true)
      resizeDirection.current = e.target.id // 리사이즈 방향 기록
    }

    // --- 히스토리 스택에 현재 상태 백업 ---
    updateHistoryStackBeforeSelect({
      boardId,
      paths,
      selectionRectPathKeys,
      historyStack,
      setHistoryStack,
    })
  }
  //==================== [ CASE 3: 예외 상황 ] ====================
  // → 어떤 조건에도 해당하지 않음 (디버깅용)
  else {
    console.warn('onPointDown select tool Error')
  }
}
